// dashboard/mixins/responsiveMixin.js
export default {
    data() {
      return {
        windowWidth: window.innerWidth,
      };
    },
    computed: {
      isMobile() {
        return this.windowWidth < 768; // 👈 adjust breakpoint as needed
      },
      isTablet() {
        return this.windowWidth >= 768 && this.windowWidth < 1024;
      },
      isDesktop() {
        return this.windowWidth >= 1024;
      },
      isMdDesktop() {
        return this.windowWidth >= 1200;
      },
    },
    created() {
      this.__handleResize = () => {
        this.windowWidth = window.innerWidth;
      };
      window.addEventListener('resize', this.__handleResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.__handleResize);
    },
};
